import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrentUser } from 'app/shivam/model/current-user';
import { AuthenticationService } from 'app/shivam/shared/auth/authentication.service';
import { NgClass, NgIf } from '@angular/common';
import { EmailValidatorDirective } from 'utils/directives/validators/email-validator';

import { ButtonDisableDirective } from 'utils/directives/helper/button-disable';

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss'],
  imports: [NgClass, FormsModule, EmailValidatorDirective, ReactiveFormsModule, NgIf]
})
export class EmailVerificationComponent implements OnInit {
  @Output() verified = new EventEmitter();
  // tslint:disable-next-line:no-output-rename
  @Output('skip') skip = new EventEmitter();
  submitted = false;
  email = new UntypedFormControl('');
  otp = new UntypedFormControl('');
  isEmailOtp = false;
  constructor(private authService: AuthenticationService) { }

  ngOnInit(): void {
    const currentUser: CurrentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!!currentUser?.email) {
      this.email.setValue(currentUser.email);
    }

  }

  submit() {
    if (this.email.invalid || this.otp.invalid) {
      this.submitted = true;
      return;
    }
    if (this.email.enabled && !!this.email.value) {
      this.authService.submitEmail(this.email.value, false).subscribe((data) => {
      });
      this.isEmailOtp = true;
      this.email.disable();
      this.otp.setValidators(Validators.required);
      this.otp.updateValueAndValidity();
      // api to sent ent otp
      // this.authService.verifyEmail(this.email.value);
    } else {
      // api to  verify otp
      if (this.otp.valid) {
        this.authService.submitEmail(this.email.value, this.otp.value).subscribe((data) => {
          if (data.result) {
            const currentUser: CurrentUser = JSON.parse(localStorage.getItem('currentUser'));
            currentUser.email = this.email.value;
            currentUser.emailVerification = 'true';
            localStorage.setItem('currentUser', JSON.stringify(currentUser));
            this.skip.emit();
          } else {
            this.submitted = true;
            this.otp.setErrors({ invalidOTP: true });
          }

        });
      }
    }

  }
  resendOtp() {
    this.authService.submitEmail(this.email.value, false).subscribe((data) => {
    });
  }
}
